import { MaintenanceAppointmentModel, MaintenanceModel } from 'api/models';

export const useMaintenanceAppointmentTask = (
  appointment: MaintenanceAppointmentModel,
  maintenance: MaintenanceModel,
) => {
  const { proServiceIds } = appointment;

  if (!proServiceIds || proServiceIds.length === 0) {
    return undefined;
  }

  if (proServiceIds.includes(maintenance.id)) {
    return maintenance;
  }

  if (maintenance.subtasks) {
    for (const subtask of maintenance.subtasks) {
      for (const item of subtask.items!) {
        // `MaintenanceGroupItemModel` has no `id` — only `uniqueId` and `jobId`,
        // both strings — so `Number(undefined)` is `NaN` and this `includes`
        // against a `number[]` can never match. The branch is dead as written;
        // which field was intended is a product question.
        // @ts-expect-error -- Legacy typecheck baseline; see docs/development/typecheck-baseline-followups.md. Refs: ARCH-56
        if (proServiceIds.includes(Number(item.maintenance!.id))) {
          return item;
        }
      }
    }
  }

  return undefined;
};
